import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import MobileWindow from './../Wrappers/MobileWindow';
import logo from '../../svg/nc-logo.svg';
import { instagram } from '../../services/api';
import { getInstagramPost } from '../../redux/business';
import { months, chunk, groupByKey, imageFix } from '../../helpers';
import './Results.css';

interface Props {
  period: any;
  loadPost: any;
  id: string;
}
interface State {
  downloadMode: boolean;
  toDownload: Array<any>;
  dates: Array<any>;
  pure?: any;
  data?: any;
  name?: string;
}

class PeriodResult extends React.Component<Props, State> {
  allIds: Array<any> = [];
  state: State = { dates: [], toDownload: [], downloadMode: false };
  constructor(props: Props) {
    super(props);
    instagram
      .getPeriodResults(this.props.period, this.props.id)
      .then((data: any) => {
        this.allIds = data.data.map((item: any) => item.id);
        const result = data.data.map((item: any) => {
          return { ...item, moment: moment.utc(item.posted_at).format('MMMM D') };
        });
        this.setState({ data: groupByKey(result, 'moment'), pure: data.data });
        const dates = Object.keys(groupByKey(result, 'moment')).sort((a, b) => {
          return new Date(b).valueOf() - new Date(a).valueOf();
        });
        const month = months[this.props.period.split('-')[1] - 1];
        const year = this.props.period.split('-')[0];
        this.setState({ name: `${month} ${year}`, dates: dates });
      })
      .catch((error) => {});
  }

  openPage(data: any) {
    this.props.loadPost(data);
  }

  addAllToDownload() {
    this.setState({ toDownload: this.allIds });
  }

  openDownload() {
    this.setState({ downloadMode: !this.state.downloadMode, toDownload: [] });
  }

  addToDownload(data: any) {
    let old = this.state.toDownload;
    for (let x in data) {
      if (!old.includes(data[x])) old.push(data[x]);
      else old.splice(old.indexOf(data[x]), 1);
    }
    this.setState({ toDownload: old });
  }

  downloadSingle(url: string) {
    const link = document.createElement('a');
    link.href = imageFix(url);
    link.download = url.split('/').pop() as string;
    document.body.appendChild(link);
    link.click();
  }

  downloadCurrent() {
    for (let x in this.state.toDownload) {
      const l = this.state.pure.filter((item: any) => item.id === this.state.toDownload[x]);
      if (l.length) {
        this.downloadSingle(l[0].media.resource_url);
      }
    }
  }

  render() {
    if (!this.state.dates)
      return (
        <MobileWindow page="monthlyReport">
          <img
            src={logo}
            alt="logo"
            className=""
            style={{ marginLeft: '30px', marginTop: '45px', width: '75px' }}
          />
          <div className="instagram-result-title">IG ACTION - ORGANIC RESULTS</div>
          <div className="offer-loader" style={{ fontSize: '20px', paddingTop: '100px' }}>
            Loading results...
          </div>
        </MobileWindow>
      );

    return (
      <div style={{}}>
        <div style={{ width: '100%' }}>
          <div className="instagram-single-result-title">{this.state.name}</div>
          <div
            style={{ float: 'right', marginTop: '13px', marginRight: '30px', cursor: 'pointer' }}
            onClick={() => this.openDownload()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="18"
              viewBox="0 0 30 18"
              style={{ marginTop: '10px', marginRight: '15px' }}
            >
              <path
                fill={this.state.downloadMode ? '#dceaeb' : '#2c3c3d'}
                fillRule="evenodd"
                d="M20.628 8.905c.01-3.104-2.505-5.641-5.6-5.65-3.105-.01-5.642 2.504-5.65 5.6-.01 3.106 2.503 5.641 5.6 5.65 3.105.01 5.641-2.504 5.65-5.6zm9.378.21c-1.79 1.912-3.668 3.732-5.856 5.183a32.986 32.986 0 0 1-3.898 2.237c-3.481 1.677-6.998 1.636-10.508.022-3.698-1.701-6.76-4.236-9.5-7.2C.168 9.273.083 9.195 0 9.114v-.469c.872-.859 1.72-1.744 2.62-2.572 2.05-1.884 4.286-3.498 6.804-4.72 3.816-1.852 7.589-1.787 11.368.098 3.384 1.687 6.24 4.048 8.802 6.795.13.14.274.267.412.4v.468zM15.009 12.16a3.288 3.288 0 0 0 3.275-3.287A3.29 3.29 0 0 0 14.997 5.6a3.29 3.29 0 0 0-3.275 3.287 3.29 3.29 0 0 0 3.287 3.275z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="25"
              height="25"
              viewBox="0 0 25 25"
            >
              <defs>
                <path
                  id="a"
                  d="M11.413 12.52V1c0-.553.484-1 1.082-1 .598 0 1.083.447 1.083 1v11.529l3.51-3.241a1.147 1.147 0 0 1 1.531 0l.064.059a.946.946 0 0 1 0 1.413l-5.358 4.947A1.131 1.131 0 0 1 12.5 16a1.131 1.131 0 0 1-.825-.292L6.317 10.76a.946.946 0 0 1 0-1.413l.064-.06a1.147 1.147 0 0 1 1.53 0l3.502 3.233zM23.148 17H25v1.447c0 3.191-2.492 5.787-5.556 5.787H5.556C2.492 24.234 0 21.638 0 18.447V17h1.852v1.447c0 2.127 1.661 3.858 3.704 3.858h13.888c2.043 0 3.704-1.73 3.704-3.858V17z"
                />
              </defs>
              <g fill="none" fillRule="evenodd">
                <mask id="b" fill="#fff">
                  <use xlinkHref="#a" />
                </mask>
                <use fill="#EEE" xlinkHref="#a" />
                <g fill={this.state.downloadMode ? '#2c3c3d' : '#dceaeb'} mask="url(#b)">
                  <path d="M0 0h25v25H0z" />
                </g>
              </g>
            </svg>
          </div>
        </div>

        <br />
        <br />
        {this.state.dates.map((item) => [
          <div className="instagram-single-result-subtitle">
            {item}
            {this.state.downloadMode ? (
              <div
                style={{
                  float: 'right',
                  display: 'inline-block',
                  fontWeight: 'initial',
                  marginRight: '10px',
                }}
                onClick={() =>
                  this.addToDownload(this.state.data[item].map((item: any) => item.id))
                }
              >
                Select
              </div>
            ) : null}
          </div>,
          chunk(this.state.data[item], 4).map((post) => {
            return (
              <div className="instagram-single-result-container">
                {post.map((x: any) => (
                  <div
                    className="instagram-single-result-picture"
                    onClick={() => {
                      this.state.downloadMode ? this.addToDownload([x.id]) : this.openPage(x);
                    }}
                  >
                    <img
                      alt="Instagram post"
                      src={imageFix(x.media.thumbnail_url)}
                      style={{ padding: '1px' }}
                    />
                    {this.state.toDownload.includes(x.id) ? (
                      <div className="download-checkmark">✓</div>
                    ) : null}
                  </div>
                ))}
              </div>
            );
          }),
        ])}
        <div
          className="download-bar"
          style={{ display: this.state.downloadMode ? 'block' : 'none' }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div
              className="download-bar-button download-bar-button--simple"
              onClick={() => this.addAllToDownload()}
            >
              SELECT ALL
            </div>

            <div
              className="download-bar-button"
              style={{ opacity: this.state.toDownload.length ? '1' : '0.4' } as any}
              onClick={() => this.downloadCurrent()}
            >
              DOWNLOAD
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return { id: state.business.business_id };
}

function mapDispatchToProps(dispatch: any) {
  return {
    goTo: (url: string) => dispatch(push(url)),
    loadPost: (data: any) => dispatch(getInstagramPost(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PeriodResult);
